import { config } from "./config";
// @ts-ignore
import useApi from "./ServiceClient.tsx";

export const useProductDesignManagement = () => {
    const { GET, POST, DELETE } = useApi(); // Use API methods inside a React hook

    const getMetaDataFieldTypes = () => {
        const response = GET(config?.design_management?.END_POINTS?.META_DATA_FIELD_TYPES);
        return response;
    };

    const getTenantHierarchy = () => {
        const response = GET(config?.design_management?.END_POINTS?.TENANT_HIERARCHY);
        return response;
    };

    const createMetaDataField = (data) => {
        const response = POST(
            config?.design_management?.END_POINTS?.META_DATA_FIELD_CREATE,
            data
        );
        return response;
    };

    const updateMetaDataField = (data) => {
        const response = POST(
            config?.design_management?.END_POINTS?.META_DATA_FIELD_UPDATE,
            data
        );
        return response;
    };

    const deleteMetaDataField = (fieldId) => {
        const response = DELETE(
            `${config?.design_management?.END_POINTS?.META_DATA_FIELD_DELETE}/${fieldId}`
        );
        return response;
    };



    return {
        getMetaDataFieldTypes,
        getTenantHierarchy,
        createMetaDataField,
        updateMetaDataField,
        deleteMetaDataField
    };
};
